import { PrimeStyleTryon } from "./PrimeStyleTryon";
import "./locales"; // Auto-register all built-in translations

// Register the custom element
if (
  typeof window !== "undefined" &&
  !customElements.get("primestyle-tryon")
) {
  customElements.define("primestyle-tryon", PrimeStyleTryon);
}

// Re-export everything for programmatic usage
export { PrimeStyleTryon } from "./PrimeStyleTryon";
export { ApiClient, PrimeStyleError } from "./api-client";
export { SseClient } from "./sse-client";
export { detectProductImage } from "./product-detector";
export { compressImage, isValidImageFile, checkAgeBeforeUpload } from "./image-utils";
export type {
  PrimeStyleConfig,
  ButtonStyles,
  ModalStyles,
  TryOnResponse,
  TryOnStatus,
  VtoUpdate,
  PrimeStyleEvents,
  FitAreaInfo,
} from "./types";
export { registerLocale, createT, SUPPORTED_LOCALES, TRANSLATION_KEYS, detectLanguage } from "./i18n";
export type { TranslateFn } from "./i18n";
